import { useQuery } from "@tanstack/react-query";
import {
  FetchExternalAccountsParams,
  getOtcExternalAccounts,
  ExternalAccountItem,
} from "../services";
import { ProviderItem } from "../components/complete-transfer";

export interface UseOtcExternalAccountsOptions extends FetchExternalAccountsParams {
  enabled?: boolean;
}

export const mapExternalAccountToProvider = (
  acc: ExternalAccountItem,
  index: number
): ProviderItem => {
  const id = acc.id || acc._id || `ext-acc-${index}`;
  const name =
    acc.account_owner_name ||
    acc.accountName ||
    acc.name ||
    "External Account";
  const accountNumber =
    acc.account_number || acc.accountNumber || "—";
  const bankName =
    acc.bank_name ||
    acc.bankName ||
    acc.bank ||
    acc.companyName ||
    "Bank";
  const routingNumber = acc.routing_number || acc.routingNumber || "";
  const email = acc.email || "";
  const relationship = acc.relationship || "";
  const accountHolderType = acc.account_type || acc.accountType || "individual";

  const streetAddress =
    acc.address?.street_line_1 ||
    acc.streetAddress ||
    "";
  const city = acc.address?.city || acc.city || "";
  const state = acc.address?.state || acc.state || "";
  const zipCode =
    acc.address?.postal_code || acc.zipCode || "";
  const addressCountry =
    acc.address?.country || acc.addressCountry || "US";

  return {
    id,
    name,
    accountNumber,
    companyName: bankName,
    avatarText: name.slice(0, 2).toUpperCase(),
    routingNumber,
    email,
    relationship,
    accountHolderType,
    streetAddress,
    city,
    state,
    zipCode,
    addressCountry,
    bankCode: acc.bankCode || "",
    nameEnquiryReference: acc.nameEnquiryReference || "",
    isDomestic: !routingNumber,
  };
};

export const useOtcExternalAccounts = (options?: UseOtcExternalAccountsOptions) => {
  const currency = options?.currency || "USD";

  const query = useQuery({
    queryKey: ["otc-external-accounts", currency],
    queryFn: () => getOtcExternalAccounts({ currency }),
  });

  console.log({query})

  const providers: ProviderItem[] = (query.data || []).map(mapExternalAccountToProvider);

  return {
    ...query,
    accounts: query.data || [],
    providers,
  };
};

